import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';

export interface Monitoreo {
  [key: string]: MonitoreoItem;
}

export interface MonitoreoItem {
  Stats: BackgroundWorkerStats | RulesStats | SystemResourcesStats | any;
  Type: string;
  Key: string;
}

export interface BackgroundWorkerStats {
  PendingProcess: number;
  InProcess: number;
  Processed: number;
  ProcessedSuccess: number;
  ProcessedFailed: number;
}

export interface RulesStats {
  Rule: string;
  Executed: number;
  Success: number;
  Failed: number;
  Average: number;
}

export interface SystemResourcesStats {
  ElapsedMillisecondsAppStart: number;
  ProcessorTime: number;
  ThreadCount: number;
  MemoryAvailableMBytes: number;
  MemoryCommittedBytesInUse: number;
}

@Injectable()
export class MonitoreoService {
  private url = 'api/monitoreo';

  constructor(private sxHttp: SxHttpService) { }

  getMonitoreo(): Observable<Monitoreo> {
    const url = `${this.url}`;
    return this.sxHttp.get(url)
      .map(response => {
        const jsonData = response.json().data;
        const result = JSON.parse(jsonData) as Monitoreo;

        return result;
      });
  }

  decodificarRegla(rule) {
      const split = rule.Rule.split('@');

      const Id = MonitoreoService.sanitize(split[0]);
      const Service = MonitoreoService.sanitize(split[1]);
      const RuleName = MonitoreoService.sanitize(split[2]);
      const Command = MonitoreoService.sanitize(split[3]);

      return { ...rule, Id, Service, RuleName, Command };
  }

  private static sanitize(text) {
    return text ? text.replace(/[\[\]]/g, '') : '';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/monitoreo.service.ts